// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2pzyx","dragIcon":"Choice_dragIcon__15Z_q","left":"Choice_left__20wCN","input":"Choice_input__1ISCV"};